module.exports = __webpack_public_path__ + "static/numbers-4-3-84ec05ab6e4b08783444c0bf4e54628f.png";